// Stage 2C T9:admin users API ラッパー
// Stage 2B 後端実装と完全对应。role_code でロール指定、enable/disable は独立端点。

import { apiFetch } from "./client";

export type RoleCode = "system_admin" | "editor" | "viewer";

export interface AdminUser {
  id: string;
  email: string;
  name: string;
  status: string;
  role_codes: RoleCode[];
  last_login_at: string | null;
  last_country: string | null;
  created_at: string;
}

export interface ListUsersResponse {
  items: AdminUser[];
  total: number;
  page: number;
  page_size: number;
}

export interface InviteResponse {
  code: string;
  email: string;
  role_code: RoleCode;
  expires_at: string;
  tenant_id: string;
  id: string;
}

export const adminApi = {
  listUsers: (params?: {
    page?: number;
    page_size?: number;
    status?: string;
    role_code?: RoleCode;
    email?: string;
  }) => {
    const qs = new URLSearchParams();
    if (params?.page) qs.set("page", String(params.page));
    if (params?.page_size) qs.set("page_size", String(params.page_size));
    if (params?.status) qs.set("status", params.status);
    if (params?.role_code) qs.set("role_code", params.role_code);
    if (params?.email) qs.set("email", params.email);
    const suffix = qs.toString() ? `?${qs.toString()}` : "";
    return apiFetch<ListUsersResponse>(`/admin/users${suffix}`);
  },

  inviteUser: (email: string, role_code: RoleCode) =>
    apiFetch<InviteResponse>("/admin/users/invite", {
      method: "POST",
      body: JSON.stringify({ email, role_code }),
    }),

  enableUser: (userId: string) =>
    apiFetch<AdminUser>(`/admin/users/${userId}/enable`, { method: "POST" }),

  disableUser: (userId: string) =>
    apiFetch<AdminUser>(`/admin/users/${userId}/disable`, { method: "POST" }),

  // PATCH 只允许 name / role_code。后端已校验，重复发送其他字段会被 400 拒绝。
  patchUser: (
    userId: string,
    fields: { name?: string; role_code?: RoleCode }
  ) =>
    apiFetch<AdminUser>(`/admin/users/${userId}`, {
      method: "PATCH",
      body: JSON.stringify(fields),
    }),
};
